import React, { useState, useEffect } from 'react';
import { Button } from '@ui/atoms/Button/Button';
function SendForCorrectionButton({ inspectionId, buttonText, iimReviewStatus, modeIA, isVisible }) {
    const [buttonVisible, setButtonVisible] = useState(isVisible);
    useEffect(() => {
        const handleTabVisibilityChange = (event) => {
            var _a, _b;
            setButtonVisible((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.isVisible) !== null && _b !== void 0 ? _b : true);
        };
        document.addEventListener('tabVisibilityChange', handleTabVisibilityChange);
        // Check active tab state on mount in case the jQuery event fired before React mounted
        const activeTab = document.querySelector('.workspace__tabs .active a');
        if (activeTab) {
            setButtonVisible(activeTab.getAttribute('href') === '#iim-issues');
        }
        return () => {
            document.removeEventListener('tabVisibilityChange', handleTabVisibilityChange);
        };
    }, []);
    if (!buttonVisible || iimReviewStatus === 'iim_completed') {
        return null;
    }
    if (['read_only', 'trial', 'teaser'].includes(modeIA)) {
        return null;
    }
    const handleClick = () => {
        document.dispatchEvent(new CustomEvent('openSendForCorrection', { detail: { inspectionId } }));
    };
    return (React.createElement(Button, { variant: "secondary", onClick: handleClick }, buttonText));
}
export default SendForCorrectionButton;
